"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _Row = _interopRequireDefault(require("@emcasa/ui-dom/components/Row"));

var _Loader = _interopRequireDefault(require("../../../shared/Loader"));

var _ref =
/*#__PURE__*/
(0, _jsx2["default"])(_Row["default"], {
  justifyContent: "center",
  alignItems: "center",
  height: "100%"
}, void 0, (0, _jsx2["default"])(_Loader["default"], {}));

var Loading =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Loading, _Component);

  function Loading() {
    (0, _classCallCheck2["default"])(this, Loading);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Loading).apply(this, arguments));
  }

  (0, _createClass2["default"])(Loading, [{
    key: "render",
    value: function render() {
      return _ref;
    }
  }]);
  return Loading;
}(_react.Component);

var _default = Loading;
exports["default"] = _default;